<template>
    <div v-if="valor" class="card card-body shadow-sm mt-0">
      <div class="form-header d-flex justify-content-between align-items-center">
        <h4 class="form-title">Detalhes do Valor</h4>
        <router-link to="/financeiro/valores">
          <button class="btn btn-secondary btn-sm">Voltar</button>
        </router-link>
      </div>
  
      <div class="form-content mt-3">
        <!-- Seção 1 -->
        <FormSection title="">
          <p><strong>Tipo:</strong> {{ valor.tipo_nome || "Não informado" }}</p>
          <p>
            <strong>Valor:</strong>
            {{ valor.valor ? utils.formatarValor(valor.valor) : "Não informado" }}
          </p>
          <p><strong>Ativo:</strong> {{ verificarAtivo(valor?.ativo) }}</p>
        </FormSection>
  
        <!-- Seção 2 -->
        <FormSection title="">
          <p><strong>Data:</strong> {{ valor.data ? utils.formatarData(valor.data) : "Não informado" }}</p>
        </FormSection>
      </div>
    </div>
  
    <div v-else>
      <LoadingSpinner />
    </div>
  </template>
  
  <script>
  import axios from "@/services/axios";
  import FormSection from "@/components/Layout/FormSection.vue";
  import globalUtils from "@/utils/globalUtils.js";
  
  export default {
    components: { FormSection },
    data() {
      return {
        valor: null,
      };
    },
  
    computed: {
      utils() {
        return globalUtils;
      }
    },
  
    methods: {
      async carregarDetalhesValor() {
        try {
          const response = await axios.get(
            `/financeiro/valores/${this.$route.params.id}`
          );
          const data = response.data;
  
          // Mapear o nome do tipo (caso não venha diretamente do backend)
          this.valor = {
            ...data,
            tipo_nome: data.tipo_nome || data.tipo || "Não informado",
          };
        } catch (error) {
          console.error("Erro ao carregar os detalhes do valor:", error);
        }
      },
  
      verificarAtivo(valor) {
        if (valor === undefined || valor === null) {
          return "Não informado";
        }
        return valor ? "Ativo" : "Inativo";
      }
    }, // 🔹 FECHANDO CORRETAMENTE O `methods`
  
    mounted() {
      this.carregarDetalhesValor();
    }
  };
  </script>
    
  <style scoped>
  .card {
    max-width: 90%;
    margin: 0 auto;
  }
  
  .form-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0rem;
  }
  
  .form-header h4 {
    margin: 0;
    font-weight: bold;
    text-align: left;
  }
  
  .form-content {
    margin-top: 1.5rem;
  }
  
  button.btn-sm {
    padding: 6px 12px;
  }
  </style>
  